import React from 'react';
import AnonFooter from './AnonFooter';
import AuthedFooter from './AuthedFooter';
import { FooterContext, FooterContextProps } from './SMFooterContext';

const SMFooter = ({
  isUserAuthenticated,
  lang,
  domain,
  subdomain,
  country,
  variant = 'default',
  showBillingAddress = false,
  isEUDC,
  isPrivateLabel = false,
  tld,
  url = undefined,
  onetrustBannerEnabled,
}: Partial<FooterContextProps>) => {
  return (
    <FooterContext
      isUserAuthenticated={isUserAuthenticated}
      lang={lang}
      subdomain={subdomain}
      domain={domain}
      country={country}
      variant={variant}
      showBillingAddress={showBillingAddress}
      isEUDC={isEUDC}
      isPrivateLabel={isPrivateLabel}
      tld={tld}
      url={url}
      onetrustBannerEnabled={onetrustBannerEnabled}
    >
      <Choose>
        <When condition={!!isUserAuthenticated}>
          <AuthedFooter />
        </When>
        <Otherwise>
          <AnonFooter />
        </Otherwise>
      </Choose>
    </FooterContext>
  );
};

export default SMFooter;
